
<mat-card class = "mat-card-header">
  <ng-content select="[banner-media]"></ng-content>

  <div class="separator-bar"></div>

  <div class="banner-container">
    <div class="tagline">
      <h2 class="mat-display-small">Sydney’s Leader in Advanced Endocrine Care</h2>
    </div>

  <div class = "banner-logos">
    <img ngSrc="./assets/StVinClin/st-vincents-clinic-logo-alt.webp"
      alt="Clinic Logo"
      class="logo clinic"
      priority
      width="366"
      height="90"
    />

    <img ngSrc="./assets/StVinClin/StVincentsPrivateHosp-logo.webp"
     alt="Hospital Logo"
     class="logo"
     priority
     width="400"
     height="149"
    />
    </div>
  </div>
</mat-card>
